import { logger } from './utils';

const RESET_PARAM = 'reset_website_data';

const LOCAL_STORAGE_KEYS = [
  'adressfinder_form_data',
  'adressfinder_url_query_string',
  'adressfinder_first_visit_time',
  'initial_url_query_string',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'auftragsnummer',
  'has_visited',
];

const SESSION_STORAGE_KEYS = ['funnel_session_id'];

export const handleResetWebsiteData = (): void => {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  if (params.get(RESET_PARAM) !== 'true') return;

  try {
    LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    SESSION_STORAGE_KEYS.forEach((key) => sessionStorage.removeItem(key));

    params.delete(RESET_PARAM);
    const newQuery = params.toString();
    const newUrl =
      window.location.pathname +
      (newQuery ? `?${newQuery}` : '') +
      window.location.hash;
    window.history.replaceState(null, '', newUrl);

    logger.log('Reset website data triggered via URL parameter — storage cleared');
  } catch (error) {
    logger.error('Error during website data reset:', error);
  }
};
